module.exports = __webpack_public_path__ + "img/pro-m-slider2.d9e31c87.png";